module.exports = __webpack_public_path__ + "img/piece-locked-3.5954aa47.svg";